import icImg from '../../assets/img/ic-img.svg';

export const commentUserName = (comment) => `${comment.user?.firstName || ''} ${comment.user?.familyName || ''}`.trim() || '—';
export const commentPrice = (comment) => comment.pricePerMonth != null
    ? `${Number(comment.pricePerMonth).toLocaleString('de-CH')} ${comment.currency || 'CHF'} / month` : '—';

export const CommentStatus = ({ status }) => (
    <span className={`comment-status ${status === 'Available' ? 'status-available' : 'status-unavailable'}`}>
        {status || '—'}
    </span>
);

export default function MobileDiscoveryCommentCard({ comment, onOpen }) {
    const photos = Array.isArray(comment.photos) ? comment.photos : [];
    return (
        <button type="button" className="mobile-comment-card" onClick={() => onOpen(comment)} aria-label={`View ${comment.commentClass || 'comment'} details`}>
            <div className="mobile-comment-card__image">
                {photos[0] ? <img src={photos[0]} alt={comment.commentClass || 'Comment photo'} loading="lazy" />
                    : <img className="mobile-comment-card__placeholder" src={icImg} alt="No attachment" />}
                {photos.length > 1 && <span className="mobile-comment-card__photo-count" aria-label={`${photos.length - 1} additional photos`}>+{photos.length - 1}</span>}
            </div>
            <div className="mobile-comment-card__body">
                <div className="mobile-comment-card__heading"><strong>{comment.commentClass || '—'}</strong><CommentStatus status={comment.status} /></div>
                <p className="mobile-comment-card__price">{commentPrice(comment)}</p>
                <p className="mobile-comment-card__excerpt">{comment.comment || comment.text || '—'}</p>
                <p>{commentUserName(comment)}</p>
                <p>Abroadify reviewed: <strong>{comment.approvedReview === true ? 'Yes' : 'No'}</strong></p>
            </div>
        </button>
    );
}
